
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    news: {
      type: Array,
      default() {
        return [];
      },
    },
    type: {
      type: String,
      default: 'news',
    },
    download: {
      type: Boolean,
      default: false,
    },
    paginate: {
      type: Boolean,
      default: true,
    },
    totalPagesCount: {
      type: Number,
      default: null,
    },
    currentPage: {
      type: [Number, String],
      default: 1,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
});
